/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IGetCustFreightTermCodeResponseV2 } from './DataServiceEntities.g';
import { getCustFreightTermCodeV3Async } from './DataActionExtension.g';
import { getCustomer, GetCustomerInput } from '@msdyn365-commerce-modules/retail-actions';

/**
 * GetCustomerFreightTermCode Input Action
 */
export class GetCustomerFreightTermCodeInput implements Msdyn365.IActionInput {
    public apiSettings: Msdyn365.ICommerceApiSettings;
    public customerAccountNumber: string;

    constructor(apiSettings: Msdyn365.ICommerceApiSettings, customerAccountNumber: string) {
        this.customerAccountNumber = customerAccountNumber;
        this.apiSettings = apiSettings;
    }

    public getCacheKey = () => 'none';
    public getCacheObjectType = () => 'none';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const apiSettings = args.requestContext.apiSettings;
    const customerAccountNumber = args.requestContext.user?.customerAccountNumber ?? '';
    return new GetCustomerFreightTermCodeInput(apiSettings, customerAccountNumber);
};

async function action(input: GetCustomerFreightTermCodeInput, ctx: Msdyn365.IActionContext): Promise<IGetCustFreightTermCodeResponseV2> {
    let customerAccountNumber = input.customerAccountNumber;

    if (!customerAccountNumber) {
        const customer = await getCustomer(new GetCustomerInput(ctx.requestContext.apiSettings), ctx);
        customerAccountNumber = customer?.AccountNumber || '';
    }

    const resp = await getCustFreightTermCodeV3Async(
        {
            callerContext: ctx
        },
        customerAccountNumber
    );
    return resp;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetCustFreightTermCodeResponseV2>>action,
    id: 'GetCustomerFreightTermCode',
    input: createInput
});
